import React, { useState } from 'react'
import AddUserToRoleModal from './AddUserToRoleModal'

interface AddUserToRoleActionProps {
  handleCloseModal: () => void
  roleName: string
  roleId?: string
}

const AddUserToRoleAction: React.FC<AddUserToRoleActionProps> = ({
  handleCloseModal,
  roleName,
  roleId
}) => {
  const [isModalOpen, setIsModalOpen] = useState(true)

  const handleClose = (): void => {
    setIsModalOpen(false)
    handleCloseModal()
  }

  return (
    <AddUserToRoleModal
      open={isModalOpen}
      onClose={handleClose}
      roleName={roleName}
      roleId={roleId}
    />
  )
}

export default AddUserToRoleAction
